export default {
      id: "rowing-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#rowing",
      toString: function () {
        return this.url;
      }
    }